import { gsap, TimelineMax } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
gsap.registerPlugin(TimelineMax, ScrollTrigger)
import homeIntro from "../modules/home/homeIntro"
import homeAbout from "../modules/home/homeAbout"
import homeSolutions from "../modules/home/homeSolutions"
import banner from "../modules/banner"
export default {
  init() {
    console.log("Nylon home")
    banner.init()
    homeIntro.init()
    homeAbout.init()
    homeSolutions.init()

  },
  finalize() {},
}
